import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=0555ca64&"
import script from "./BillOfLading.vue?vue&type=script&lang=js&"
export * from "./BillOfLading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports